import { useBreakpointValue } from "@chakra-ui/react"

export const useCarouselDimension = (
  columnWidthXs: number,
  columnWidthMd: number,
  columnWidth: number
) => {
  const defaultWidth = 50

  const carouselWidth =
    useBreakpointValue({
      base: columnWidthXs,
      md: columnWidthMd,
      lg: columnWidth,
    }) ?? defaultWidth

  const contentWidth =
    useBreakpointValue({
      base: "100%",
      md: 100 - columnWidthMd,
      lg: 100 - columnWidth,
    }) ?? defaultWidth

  return { carouselWidth, contentWidth }
}
